import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const EquipmentMaster = React.lazy(() => import('.'));

export const equipmentMasterRoutes = [
  new Route({
    path: 'equipment-master',
    element: EquipmentMaster,
    children: [],
  }),
];
